import { tool, zodSchema } from 'ai';
import { z } from 'zod';
import type { AiTool } from '@erikdakoda/ai-tool/types';
import { withAiToolNestedParamSchema } from '@erikdakoda/ai-tool/findManyAiToolInput';
import { botsToolGroupIcon } from './toolGroupIcon';
import { ormToolQueryArgsSchema } from '@erikdakoda/ai-tool/types';
import { BotForAiToolsSchema } from './BotForAiTools';
import { createBotSelectSchema } from './botAiToolInputSchemas';

/** Create payload: omit server-managed fields (`id`, `slug`, `updatedAt`). */
export const createBotBodySchema = BotForAiToolsSchema.omit({
  id: true,
  slug: true,
  createdAt: true,
  updatedAt: true,
});

export const createBotInputSchema = z.object({
  bot: withAiToolNestedParamSchema(createBotBodySchema, 'bot').describe(
    'Bot to create, including ownerId and spaceId.',
  ),
  select: createBotSelectSchema,
});

export const createBotOutputSchema = z.object({
  queryArgs: ormToolQueryArgsSchema,
  queryResult: z
    .unknown()
    .nullable()
    .describe('Created row; default mask when `select` omitted, else matches caller `select`.'),
  success: z.string().nullable(),
  error: z.unknown().nullable(),
});

export type CreateBotInput = z.infer<typeof createBotInputSchema>;
export type CreateBotOutput = z.infer<typeof createBotOutputSchema>;

export const createBot: AiTool<undefined, CreateBotInput, CreateBotOutput> = {
  id: 'createBot',

  group: 'bots',

  ...botsToolGroupIcon,

  userSelect: false,

  access: 'WRITE',

  tool: tool({
    description: `Create a bot for a user and space.`,
    inputSchema: zodSchema(createBotInputSchema),
    outputSchema: zodSchema(createBotOutputSchema),
  }),
};
